import React from 'react';
import cls from './CharterItem.module.css';
import classNames from 'classnames';
import { usePlanFact } from '../../../hooks/usePlanFact';
import { getFinalWidth } from '../../../helpers/getFinalWidth';
import { useSelector } from 'react-redux';

export const PlanFactCharterItem = ({ charter }) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const { planWidth, factWidth, factLeft } = usePlanFact(charter, 'charter', activeTab);

    let finalWidth = getFinalWidth(planWidth, activeTab, charter.planned.days_count);
    let finalWidthFact = getFinalWidth(factWidth, activeTab, charter.planned.days_count);

    let isShowSmallMain = true;
    let isShowSmallMainFact = true;

    if (activeTab !== 'day') {
        if (activeTab === 'week' && +charter.planned.days_count < 2) {
            isShowSmallMain = false;
        }
        if (activeTab === 'week' && +charter.actual.days_count < 2) {
            isShowSmallMainFact = false;
        }
        if (activeTab === 'month' && +charter.planned.days_count < 3) {
            isShowSmallMain = false;
        }
        if (activeTab === 'month' && +charter.actual.days_count < 3) {
            isShowSmallMainFact = false;
        }
    }

    return (
        <div className={classNames(cls.wrapper)}>
            <div className={cls.planElementWrapper}>
                <div
                    style={{ width: finalWidth + (isShowSmallMain ? 1 : 0) }}
                    className={classNames(!isShowSmallMain ? cls.smallWrapper : cls.planElement)}
                />
            </div>
            <div
                style={{ left: factLeft }}
                className={classNames(cls.charterItem, { [cls.planFact]: isPlanFact })}
            >
                {isShowSmallMainFact && (
                    <svg
                        width="12"
                        height="28"
                        viewBox="0 0 12 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V24C12 26.2091 10.2091 28 8 28H4C1.79086 28 0 26.2091 0 24V4Z"
                            fill={charter.done_percent > 0 ? ' #FFC62E' : '#FFF0D5'}
                        />
                        <path
                            d="M12 6H8V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V23C4 23.5523 4.44772 24 5 24H7C7.55228 24 8 23.5523 8 23V22H12V24C12 26.2091 10.2091 28 8 28H4C1.79086 28 0 26.2091 0 24V4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V6Z"
                            fill="#FFC62E"
                        />
                    </svg>
                )}
                {/*<ReactTooltip*/}
                {/*    id={`diagram-charter-${charter.guid}`}*/}
                {/*    aria-haspopup="true"*/}
                {/*    effect="solid"*/}
                {/*    delayHide={200}*/}
                {/*    delayShow={200}*/}
                {/*    type="light"*/}
                {/*    className={cls.tooltip}*/}
                {/*>*/}
                {/*    <p>{charter.name}</p>*/}
                {/*</ReactTooltip>*/}
                <div
                    data-tip
                    title={charter.name}
                    data-for={`diagram-charter-${charter.guid}`}
                    className={classNames(cls.MainElement, {
                        [cls.backgroundFact]: isPlanFact,
                        [cls.small]: Number(charter.actual.days_count) < 5,
                        [cls.smallElement]: !isShowSmallMainFact,
                        [cls.notRightPadding]:
                            (+charter.planned.days_count < 3 && activeTab !== 'day') ||
                            (factWidth < 22 && activeTab !== 'day'),
                    })}
                    style={{
                        width: finalWidthFact - (isShowSmallMainFact ? 1 : 0),
                        cursor: 'auto',
                        '--width': charter.done_percent,
                    }}
                >
                    <span className={cls.text}>{charter?.name}</span>
                </div>

                {isShowSmallMainFact && (
                    <svg
                        style={{ marginLeft: '-1px' }}
                        width="12"
                        height="28"
                        viewBox="0 0 12 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 4C12 1.79086 10.2091 0 8 0H4C1.7909 0 0 1.79086 0 4V24C0 26.2091 1.7909 28 4 28H8C10.2091 28 12 26.2091 12 24V4Z"
                            fill={charter.done_percent >= 100 ? ' #FFC62E' : '#FFF0D5'}
                        />
                        <path
                            d="M0 6H4V5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5V23C8 23.5523 7.55228 24 7 24H5C4.44772 24 4 23.5523 4 23V22H0V24C0 26.2091 1.79086 28 4 28H6H8C10.2091 28 12 26.2091 12 24V4C12 1.79086 10.2091 0 8 0H4C1.79086 0 0 1.79086 0 4V6Z"
                            fill="#FFC62E"
                        />
                    </svg>
                )}
            </div>
        </div>
    );
};
